import {
  Image,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import { Colors, Typography } from "../../styles";
import { useDispatch, useSelector } from "react-redux";
import { selectUser, setBottomSheet } from "../../redux/mainSlice";

const Button = ({
  title,
  screen,
  icon,
  navigation,
  focused,
  longPress,
}: {
  title: string;
  screen: string;
  icon: React.ReactNode;
  navigation: any;
  focused: boolean;
  longPress?: () => void;
}) => (
  <TouchableWithoutFeedback
    onPress={() => navigation.navigate(screen)}
    onLongPress={longPress}
  >
    <View style={[styles.button, focused && styles.focusedButton]}>
      <View style={styles.icon}>{icon}</View>
      <Text style={[Typography.paragraph, { fontSize: 12 }]}>{title}</Text>
    </View>
  </TouchableWithoutFeedback>
);

const TabBar = ({ state, navigation }: { state: any; navigation: any }) => {
  const dispatch = useDispatch();

  const user = useSelector(selectUser);

  return (
    <View style={styles.container}>
      <Button
        title="Today"
        screen="Today"
        icon={
          <Image
            source={require("../../assets/images/logo.png")}
            style={{ height: 20, width: 20, marginBottom: 2 }}
            resizeMode="contain"
          />
        }
        navigation={navigation}
        focused={state.index === 0}
      />
      <Button
        title="Discover"
        screen="Discover"
        icon={<FontAwesome name="search" size={20} color={Colors.white} />}
        navigation={navigation}
        focused={state.index === 1}
      />
      <Button
        title={user.name}
        screen="Profile"
        icon={
          <View
            style={{
              width: 25,
              height: 25,
              borderRadius: 25 / 2,
              overflow: "hidden",
              borderWidth: 1,
              borderColor: Colors.white,
            }}
          >
            <Image
              source={{
                uri: user.image,
              }}
              style={{ height: "100%", width: "100%" }}
              resizeMode="cover"
            />
          </View>
        }
        navigation={navigation}
        focused={state.index === 2}
        longPress={() => dispatch(setBottomSheet("profiles"))}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: Colors.plum900,
    flexDirection: "row",
    justifyContent: "space-around",
    paddingVertical: 13,
  },
  button: {
    alignItems: "center",
    opacity: 0.5,
  },
  focusedButton: {
    opacity: 1,
  },
  icon: {
    height: 30,
    justifyContent: "center",
  },
});

export default TabBar;
